import { APIConfiguration } from '@savgroup-front-common/configuration';
import { CIVILITY } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';
import { CarrierAddress } from '@savgroup-front-common/types/CarrierAddress';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.carrier}label/verify`;

export interface VerifyAddressCommandArgs {
  carrierCompany?: string;
  address: CarrierAddress;
  verifyStrict?: boolean;
}

export interface VerifiedAddressSummary {
  city: string;
  civility: CIVILITY;
  country: string;
  countryCode: string;
  name1: string;
  name2: string;
  phone: string;
  state: string;
  street1: string;
  street2: string;
  zipCode: string;
}

export const verifyAddressRequest = ({
  carrierCompany,
  address,
  verifyStrict,
}: VerifyAddressCommandArgs): ApiRequestDescriptor => ({
  url: ENDPOINT,
  config: {
    method: SUPPORTED_METHODS.POST,
    json: {
      carrierCompany,
      address,
      verifyStrict,
    },
  },
});

export const verifyAddressCommand = async (
  payload: VerifyAddressCommandArgs,
): Promise<BackResponse<VerifiedAddressSummary> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<VerifiedAddressSummary>>(
      verifyAddressRequest(payload),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
